export const Endpoint = () => `/api/v3/admin/archives`;

export const QueryKey = () => ['v3', 'admin', 'archives', 'list'] as const;

export interface ArchiveRaw {
    readonly filename: string;
    readonly touchTime: string;
    readonly uploadTime: string;
    readonly writeTime: string;
}

export type Response = ArchiveRaw[];
